import { useEffect, useState } from "react";

export function isMobileDevice(width, maxWidth = 768) {
    if (width) {
        return width <= maxWidth;
    }
    const userAgentCheck = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
    const screenCheck = window.innerWidth <= maxWidth;
    return userAgentCheck || screenCheck;
}

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    window.addEventListener("resize", handleResize);

    // cleanup para evitar vazamento de memória
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
}

export default useWindowSize;
